<template>
  <div>
    <c-search-box @enter="getSearchList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 업체분류 -->
          <c-select
            codeGroupCd="VENDOR_CLASS_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="vendorClassCd"
            label="LBL0003027"
            v-model="searchParam.vendorClassCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 업체유형 -->
          <c-select
            codeGroupCd="VENDOR_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="vendorTypeCd"
            label="LBL0003028"
            v-model="searchParam.vendorTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사용여부 -->
          <c-select
            :comboItems="useFlagItems"
            type="edit"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="LBLUSEFLAG"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            label="업체"
            name="vendorName"
            type="search"
            v-model="searchParam.vendorName">
          </c-text>
        </div> -->
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
        <!-- 수급업체 목록 -->
        <c-table
          ref="vendorTable"
          title="LBL0003029"
          :columns="grid.columns"
          :data="grid.data"
          :columnSetting="false"
          :isFullScreen="false"
          :expandAll="true"
          @rowClick="rowClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <!-- 검색 -->
              <c-btn label="LBLSEARCH" icon="search" @btnClicked="getSearchList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
        <c-tab
          type="tabcard"
          :tabItems.sync="tabItems"
          :inlineLabel="true"
          v-model="tab"
          align="left"
        >
          <template v-slot:default="tab">
            <component v-if="tab.name=='vendorDetail'"
              ref="vendorDetail"
              :is="tab.component"
              @searchDetail="getVendorList"
              @isNew="reset"
              :parentVendorCd="selectedVendorCd"
            />
            <component v-else-if="tab.name=='vendorUser'"
              ref="vendorUser"
              :is="tab.component"
              @searchDetail="getVendorList"
              @isNew="reset"
              :parentVendorCd="selectedVendorCd"
            />
            <component v-else-if="tab.name=='vendorRelatedAttach'"
              ref="vendorRelatedAttach"
              :is="tab.component"
              @searchDetail="getVendorList"
              @isNew="reset"
              :parentVendorCd="selectedVendorCd"
            />
          </template>
        </c-tab>
      </div>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'vendor-manage',
  data() {
    return {
      searchParam: {
        vendorTypeCd: null,
        plantCd: null,
        vendorClassCd: null,
        vendorName: '',
        useFlag: 'Y',
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      tab: 'vendorDetail',
      tabItems: [
        // 상세정보
        { name: 'vendorDetail', icon: 'list', label: 'LBL0003046', component: () => import(`${'./vendorDetail.vue'}`) },
        // 근무인원
        { name: 'vendorUser', icon: 'info', label: 'LBL0003047', component: () => import(`${'./vendorUser.vue'}`) },
        // 관련서류
        { name: 'vendorRelatedAttach', icon: 'folder', label: 'LBL0003048', component: () => import(`${'./vendorRelatedAttach.vue'}`) },
      ],
      grid: {
        columns: [
          {
            name: 'vendorName',
            field: 'vendorName',
            // 업체
            label: 'LBL0003030',
            align: 'left',
            sortable: true,
            style: 'width:130px',
          },
          {
            name: 'vendorClassName',
            field: 'vendorClassName',
            // 업체분류
            label: 'LBL0003027',
            align: 'center',
            style: 'width:70px',
            sortable: true,
          },
          {
            name: 'vendorTypeName',
            field: 'vendorTypeName',
            // 업체유형
            label: 'LBL0003028',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            name: 'plantNames',
            field: 'plantNames',
            // 관련사업장
            label: 'LBL0003031',
            align: 'left',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            // 사용여부
            label: 'LBLUSEFLAG',
            align: 'center',
            style: 'width:50px',
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      selectedVendorCd: '',
      selectedVendor: [],
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.mdm.cim.vendor.list.url;
      this.getList();
    },
    rowRemoveSelect() {
      var _table = document.getElementsByClassName('bg-light-blue-1')[0];
      if (_table) {
        _table.classList.remove('bg-light-blue-1');
      }
    },
    getSearchList() {
      this.getList();
      this.reset();
    },
    getVendorList() {
      this.getList();
      if (this.selectedVendorCd == '') {
        this.reset();
      }
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
        if (this.selectedVendorCd != '') {
          this.$refs["vendorDetail"].rowClick({ vendorCd: this.selectedVendorCd });
        } else {
          if (this.$refs["vendorDetail"] !== undefined) {
            this.$refs["vendorDetail"].reset();
          }
        }
      },);
    },
    rowClick(row) {
      this.selectedVendor = row;
      this.selectedVendorCd = row.vendorCd;
    },
    reset() {
      this.rowRemoveSelect();
      this.selectedVendorCd = '';
      this.selectedVendor = [];
    }
  }
};
</script>
